// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const CustomerEquipmentLayout = ({ children }) => {

	return (
		<div className='CustomerEquipmentLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title='Customer Equipment'/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

CustomerEquipmentLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

CustomerEquipmentLayout.defaultProps = {
	children: null,
	title: ''
}

export default CustomerEquipmentLayout